export default function ({ store, route }) {
    store.commit('redirect/SET_LOGIN_CALLBACK', route.fullPath);
}
